import React from 'react'
import styled from 'styled-components'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Card } from 'antd';

import Layout from '../../components/Layout'
import Steps from '../../components/Steps'
import Button from '../../components/Button'

import constants from '../../config/constants'

import steps from '../../assets/images/steps.svg'
import bg from '../../assets/images/bg.png'

const Background = styled.div`
  height: 100%;
  margin: 0 -15px;
  width: auto;
`

const StyledImg = styled.img`
  max-height: 300px;
  width: 100%;
  object-fit: cover;
  object-position: center;
  height: auto;
`

const Main = styled.div`
  position: absolute;
  top: 5rem;
  width: 90%;
  height: 100%;
`

const Contant = styled(Card)`
  border-radius: 15px !important;
  border: none !important;
  width: 100% !important;
  height: 100% !important;

  .ant-card-body {
    padding: 0 !important;
  }
`

const MainImg = styled.div`
  text-align: center;
`

const MainDetail = styled.div`
  padding-top: 1rem;
`
const Detail = styled.div`
  text-align: center;
`

const Description = styled.p`
  color : ${constants.color.dark};
  font-size: 14px;
`

const OnBoardingStage = (props) => {
  return (
    <Layout title={'ขั้นตอนการสมัครกองทุนรวม'} backIcon={true} onClick={() => props.history.goBack()}>
      <Background>
        <StyledImg src={bg}/>
      </Background>
      <Main>
        <Contant>
          <MainImg>
            <LazyLoadImage
              alt=''
              height={150}
              visibleByDefault={true}
              src={steps}
              width={150} />
          </MainImg>
          <MainDetail>
            <Detail>
              <h4>จัดการกองทุนรวมง่ายๆใน 4 ขั้นตอน</h4>
              <Description>กรุณาดำเนินการตามนี้</Description>
            </Detail>
            <Steps current={2} />
          </MainDetail>
          <Button
            textcolor={constants.color.white}
            bordercolor={constants.color.orange}
            backgroundcolor={constants.color.orange}
            text={'ทำรายการต่อ'}
            disabled={false}
            onClick={() => props.history.push('/personal-information-form')}
          />
        </Contant>
      </Main>
    </Layout>
  )
}

export default OnBoardingStage
